type RatingValueTextProps = {
  /** Rating value (Figma `rating_value_text`). */
  value?: string;
};

const DEFAULT_VALUE = '4,2';

/** Figma `rating_value_text` (104:24631) — Shnobel 51.056, shadow #4D3C82. */
export function RatingValueText({ value = DEFAULT_VALUE }: RatingValueTextProps) {
  return (
    <svg
      className="rating-screen-button__rating-value"
      width={62}
      height={53}
      viewBox="0 0 62 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <text
        className="rating-screen-button__rating-value-text"
        textAnchor="middle"
        xmlSpace="preserve"
      >
        <tspan x={31} y={46}>
          {value}
        </tspan>
      </text>
    </svg>
  );
}
